<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts';
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      chart: null,
      loadingConfig: {
        text: '加载中...',
        color: '#017dfa',
        textColor: '#999',
        maskColor: 'rgba(0, 0, 0, 0.5)',
        zlevel: 0
      }
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        if(val.yData == null) {
          this.chart.showLoading(this.loadingConfig)
        } else {
          this.chart.hideLoading()
        }
        this.setOptions(val, this.unit, this.min, this.max)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      // this.chart.showLoading()
      if(this.chartData.yData == null) {
        this.chart.showLoading(this.loadingConfig)
      } 
      this.setOptions(this.chartData, this.unit, this.min, this.max)
      // this.chart.hideLoading()
    },
    setOptions({ xData, yData } = {}, unit = '', min = null, max = null) {
      this.chart.setOption({
        title: {
          text: this.title,
          left: 'center',
          textStyle: {
            color: '#6ab8ff',
            fontWeight: 'bold',
          },
          padding: 0
        },
        xAxis: {
          data: xData,
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#aab6e4',
            fontSize: 14
          },
          axisLine: {
            lineStyle: {
              color: '#aab6e4'
            }
          }
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 30,
          top: 20,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10],
          // formatter: '照片数：{c}<br />时间：{b}'
          formatter: function (params) {
            console.log(params)
            // params 是一个数组，包含了多个 tooltip 项
            var res = params[0].name + '<br/>';
            for (var i = 0, l = params.length; i < l; i++) {
              if(params[i].value === undefined) {
                res += params[i].marker + params[i].seriesName + ' : -<br/>';
              } else {
                res += params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit + '<br/>'
              }
            }
            return res;
          }
        },
        yAxis: {
          min,
          max,
          axisTick: {
            show: false
          },
          minInterval: 1,
          axisLabel: {
            color: '#aab6e4',
            fontSize: 14
          },
          axisLine: {
            lineStyle: {
              color: '#aab6e4'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#aab6e4'
            }
          }
        },
        legend: {
          // data: ['expected'],
          // show: false
          bottom: 0,
          left: 'center',
          // itemHeight: 10,
          textStyle: {
            color: '#aab6e4',
            fontSize: 14,
          },
          inactiveColor: '#4f556c'
        },
        series: yData
      })
    }
  }
}
</script>